'use client'

import Icon from '@/components/ui/icon'
import useScrollProperties from '@/hooks/useScrollProperties'

export default function BackToTop() {
  const { distanceFromTop } = useScrollProperties({
    debounceDuration: 300,
  })

  const activeClass = distanceFromTop >= 660 ? 'opacity-100' : 'opacity-0 pointer-events-none' // trigger roughly after hero

  return (
    <button
      tabIndex={-1}
      onClick={() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth',
        })
      }}
      aria-label="Return to the top of the website"
      className={`${activeClass} fixed bottom-[16px] right-[16px] z-50 flex h-[44px] w-[44px] items-center justify-center rounded-full bg-primary text-white shadow-md duration-300 hover:-translate-y-[2px]`}>
      <Icon id="icon-chevron-up" width={26} height={26}></Icon>
    </button>
  )
}
